'use client';

import { useContext } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import { ModalContext } from 'components/shared/Modal';
import { PLCTA } from 'components/performance-lab/PLCTA';
import { analytics } from 'lib/analytics/analytics';
import { jetbrainsMono } from 'utils/fonts';
import { PL_PARTNERS_HERO } from './plPartnersConstants';
import { PlPartnersTypeformModal } from './PlPartnersTypeformModal';
import styles from './PlPartnersPage.module.css';

export const PlPartnersPage = () => {
  const t = useTranslations('performance-lab');
  const modal = useContext(ModalContext);

  const openModal = () => {
    analytics.track('performance lab - Register interest - CLICK');
    modal.set(<PlPartnersTypeformModal />);
    modal.setCloseButtonTheme('light');
    modal.show();
  };

  return (
    <main className={styles.page} aria-label={t('partnersPage.mainAria')}>
      <div className={styles.imageCol}>
        <div className={styles.imageDesktop}>
          <CustomImage
            src={PL_PARTNERS_HERO.desktop}
            alt={t('partnersPage.heroAlt')}
            fill
            priority
            sizes="50vw"
            style={{ objectFit: 'cover' }}
          />
        </div>
        <div className={styles.imageMobile}>
          <CustomImage
            src={PL_PARTNERS_HERO.mobile}
            alt={t('partnersPage.heroAlt')}
            fill
            priority
            sizes="calc(100vw - 32px)"
            style={{ objectFit: 'cover' }}
          />
        </div>
      </div>
      <div className={styles.copyCol}>
        <p className={`${styles.eyebrow} ${jetbrainsMono.className}`}>
          {t('partnersPage.eyebrow')}
        </p>
        <h1 className={styles.title}>{t('partnersPage.title')}</h1>
        <p className={styles.lede}>{t('partnersPage.lede')}</p>
        <div className={styles.copySlot}>
          <PLCTA
            type="button"
            $plVariant="primary"
            data-buttontype="performance_lab_partners_register_interest"
            onClick={openModal}
          >
            {t('partnersPage.cta')}
          </PLCTA>
        </div>
      </div>
    </main>
  );
};
